module.exports = __webpack_public_path__ + "img/Entia-Generacion-de-energia-medio-ambiente-3.888f51cd.webp";